import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight } from '@styled-icons/material/ChevronRight';
import { Text, TextVariant } from '@naf/text';
import { useDocumentUrlWithNode } from '../../../hooks/Documents/useDocumentUrl';
import { MenuSectionHeader } from '../../../../../types/globalSettingsType';
import { useHandleNavigationClick } from '../../../utils/Tracking/Navigation/NavigationTracking';
import { DesktopWrapper } from '../../../utils/Styles/Wrappers';
import * as S from './MenuSectionHeader.styles';

interface MenuSectionHeaderProps {
  link?: MenuSectionHeader | null;
  header?: string;
}

export const MegaMenuSectionHeader: React.FC<MenuSectionHeaderProps> = ({ link, header }) => {
  const location = useLocation();
  const refUrl = useDocumentUrlWithNode(link?.data) || '';
  const handleOnClick = useHandleNavigationClick({
    event: 'megaMenuClick',
    menuPage: location.pathname,
    menuSectionName: header ?? '',
    menuItemUrl: refUrl,
  });

  if (!header || !refUrl) return null;

  return (
    <DesktopWrapper>
      <S.MenuItemHeader to={refUrl} onClick={handleOnClick}>
        <Text tag="span" variant={TextVariant.Header3}>
          {header}
          <ChevronRight size={24} />
        </Text>
      </S.MenuItemHeader>
    </DesktopWrapper>
  );
};
